"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollHistoryItem = void 0;
var tslib_1 = require("tslib");
var history_item_1 = require("../../../../core/model/history/base/history-item");
var flag_1 = require("@devexpress/utils/lib/class/flag");
var history_item_direction_1 = require("./history-item-direction");
var ScrollHistoryItem = (function (_super) {
    tslib_1.__extends(ScrollHistoryItem, _super);
    function ScrollHistoryItem(modelManipulator, selection, oldState, newState, directionValue) {
        if (directionValue === void 0) { directionValue = history_item_direction_1.HistoryItemDirection.OnRedoAndUndo; }
        var _this = _super.call(this, modelManipulator) || this;
        _this.selection = selection;
        _this.newState = newState;
        _this.oldState = oldState;
        _this.directionFlag = new flag_1.Flag(directionValue);
        return _this;
    }
    ScrollHistoryItem.prototype.canBeMerged = function () {
        return true;
    };
    ScrollHistoryItem.prototype.redo = function () {
        if (this.directionFlag.get(history_item_direction_1.HistoryItemDirection.OnRedo))
            this.selection.scrollManager.setScroll(this.newState);
    };
    ScrollHistoryItem.prototype.undo = function () {
        if (this.directionFlag.get(history_item_direction_1.HistoryItemDirection.OnUndo))
            this.selection.scrollManager.setScroll(this.oldState);
    };
    return ScrollHistoryItem;
}(history_item_1.HistoryItem));
exports.ScrollHistoryItem = ScrollHistoryItem;
